export function scroll_if_anchor(href, args) {
    href = typeof (href) === "string" ? href : jQuery(this).attr("href");

    if (!href) return;

    let options = jQuery.extend({
        'speed': 200,
        'fromtop': 0
    }, args);

    let hash = href.substring(href.indexOf('#'));

    if (href.indexOf('#?') > -1) {
        return;
    }

    if (hash === '#pricingModal') {
        return;
    }

    let target = jQuery(hash);
    let fromTop = options.fromtop;

    if (target.length === 0) {
        hash = hash.replace("#", "");

        if (hash.length) {
            target = jQuery('[name="' + hash + ']"');
        }
    }

    if (target.length) {
        history.scrollRestoration = 'manual';
        jQuery('html, body').animate({scrollTop: target.offset().top - fromTop}, options.speed);
    }
}


export function initParentClick() {
    document.querySelectorAll<HTMLElement>('[data-parentclick]').forEach(element => {
        const link = element.querySelector<HTMLAnchorElement>('a');
        if (!link) return;

        element.style.cursor = 'pointer';
        element.addEventListener('click', event => {
            element.querySelector<HTMLAnchorElement>('a')?.click();
        });
    });
}

export function getUrlParameter(sParam) {
    let sPageURL = decodeURIComponent(window.location.search.substring(1)),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
            return sParameterName[1] === undefined ? true : sParameterName[1];
        }
    }
}